import ApplicationSerializer from "./application";

export default class EmailAliasSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "emailalias";

  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    let normalizedPayload = {
      ...payload.response,
      emailaliases: payload.response.list.emailaliases,
    };

    delete normalizedPayload.list;

    return super.normalizeArrayResponse(store, primaryModelClass, normalizedPayload, id, requestType);
  }
}
